import { useCallback, useEffect, useMemo, useState } from 'react';

import { IUiMultiSelectProps } from '@shared/ui/UiMultiSelect/model/types';

interface IUseSearchValueProps {
    needSearch: boolean;
    options: IUiMultiSelectProps['options'];
    isOpen: boolean;
}

export const useSearchValue = ({ needSearch, options, isOpen }: IUseSearchValueProps) => {
    const [filter, setFilter] = useState('');

    const filteredOptions = useMemo(() => {
        if (needSearch && filter) {
            return options?.filter((option) =>
                option.label.toLowerCase().includes(filter.toLowerCase())
            );
        }
        return options;
    }, [options, filter, needSearch]);

    const handleFilterChange = useCallback(
        (_: string, value: string) => {
            setFilter(value);
            // setHighlightedIndex(0);
        },
        // [setHighlightedIndex]
        []
    );

    useEffect(() => {
        if (!isOpen) {
            setFilter('');
        }
    }, [isOpen]);

    return {
        filteredOptions,
        handleFilterChange,
        filter,
    };
};
